import React from "react";
import T from "prop-types";
import { Row, Col } from "react-bootstrap";
import moment from "moment";
import withCurrentUser from "MODULES/session/decorators/withCurrentUser";
import { Stat } from "MODULES/shared/components";
import numeral from "numeral";
import { withPolling } from "MODULES/shared/decorators";
import { DepreciationsSum } from "./Stats";

function MonthlyStats({ currentUser, selectedDate, depreciationsData }) {
  const date = moment(selectedDate).format("MMMM YYYY");

  return (
    <Row>
      {currentUser.locations.length > 1 &&
        depreciationsData.perLocation.map(l => (
          <Col md={3} lg={3}>
            <Stat
              label={`$ Depreciations ${l.location}`}
              value={numeral(
                Number(l.total_depreciations) + Number(l.total_write_downs)
              ).format("($0,0)")}
              labelFontSize="44px"
            />
          </Col>
        ))}
      <Col md={3}>
        <DepreciationsSum dateLabel={date} data={depreciationsData} />
      </Col>
    </Row>
  );
}

MonthlyStats.propTypes = {
  currentUser: T.shape({}),
  selectedDate: T.string,
  depreciationsData: T.arrayOf(T.shape({}))
};

export default withCurrentUser(withPolling(MonthlyStats));



// WEBPACK FOOTER //
// ./app/modules/DepreciationsDashboard/Components/MonthlyStats.jsx